/**
 * GlobalConnectionToast
 *
 * Wraps ConnectionToast so it only renders where there's no other
 * connection-status surface to duplicate. PortalHeader's
 * ConnectionStatusBanner already covers every /portal route with the same
 * connection events (reconnecting / failed / offline) — mounting the toast
 * unconditionally at the app root meant a user on any portal page saw two
 * independently-firing surfaces with overlapping but not-quite-matching
 * copy for one event. The toast stays for everything outside the portal
 * shell (e.g. /login), where no banner exists to cover it.
 */

import React from "react";
import { useLocation } from "react-router-dom";
import { ConnectionToast } from "./ConnectionToast";

/**
 * Pure so the routing rule is testable without rendering. Matches "/portal"
 * itself and any "/portal/..." path, but not an unrelated route that merely
 * starts with the same letters (e.g. a hypothetical "/portalio").
 */
export function shouldSuppressGlobalToast(pathname: string): boolean {
  return pathname === "/portal" || pathname.startsWith("/portal/");
}

export const GlobalConnectionToast: React.FC = () => {
  const location = useLocation();
  if (shouldSuppressGlobalToast(location.pathname)) {
    return null;
  }
  return <ConnectionToast />;
};

export default GlobalConnectionToast;
